import { VIEW_INFO_POPUP } from './constants'

export const initialState = {
  individualMemberForPopup: null,
  isPopupOpen: false,
  orgAdminsToRemove: {},
  pending: false,
  popupView: VIEW_INFO_POPUP,
  pageType: null
}
